import { Keyboard } from '@capacitor/keyboard';
import { StatusBarPlugin, StatusBar, Style as StatusBarStyle, StyleOptions, BackgroundColorOptions } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Plugins } from '@capacitor/core';
import { Camera, CameraSource, CameraResultType, Photo } from '@capacitor/camera';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { AppLauncher, CanOpenURLResult } from '@capacitor/app-launcher';
import { OpenURLResult } from '@capacitor/app-launcher/dist/esm/definitions';
import { NativeSettings, IOSSettings } from 'capacitor-native-settings';
import { Intercom } from '@capacitor-community/intercom';
// myPOS Plugins
import { TransactionResult, ConnectOptions, PayOptions, IMyPosMiniPlugin } from '@paymash/capacitor-mypos-mini-types';
import { MyPosMiniPlugin } from '@paymash/capacitor-mypos-mini-plugin';
import {
  IMyPosTransactionResult,
  IMyPosInfo,
  MyPosScannerResult,
  MyposN5PluginError,
  MyPosScannerType,
  MyPosN5Plugin
} from '@paymash/capacitor-mypos-plugin';
import { MyposGlassErrorCode, NfcState } from '@paymash/capacitor-mypos-glass-plugin/dist/esm/models';
import {
  MakePaymentOptions,
  MakeRefundOptions,
  MyposGlassError,
  MyposGlassPlugin,
  PosInfo,
  TransactionResponse,
  TransactionResponse as MyposGlassTransactionResponse
} from '@paymash/capacitor-mypos-glass-plugin';
// SIX
import {
  TimApiPlugin,
  TimApiTerminalStatus,
  TimApiError,
  TimApiErrorResultCode,
  ITimApiPaymentResult,
  TimApiTerminalConnectionParams,
  TimApiTerminalInterface
} from '@paymash/capacitor-tim-api-plugin';
// SumUp
import { SumupPlugin } from '@paymash/capacitor-sumup-plugin';
// Sunmi
import { SunmiScannerType, SunmiScannerPlugin, SunmiPrinterPlugin } from '@paymash/capacitor-sunmi-plugin';
// Customer display
import { createCustomerDisplayServerPlugin } from '@paymash/capacitor-customer-display-inapp-plugin';
// Scanners
import {
  SocketScannerPlugin,
  ScannerAppInfo,
  ScannerResultAction,
  SocketScannerPluginError
} from '@paymash/capacitor-socket-scanner-plugin';
// Crypto
import { createCipheriv, createDecipheriv, createHmac, randomBytes, Cipher, pbkdf2Sync } from 'crypto';

import { InAppBrowser, InAppBrowserObject, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';

const { PushNotifications } = Plugins;

const requestCameraPermissions = () => {
  return Camera.requestPermissions({ permissions: ['camera'] }).then((status) => status.camera);
};

const requestGalleryPermissions = () => {
  return Camera.requestPermissions({ permissions: ['photos'] }).then((status) => status.photos);
};

export {
  Keyboard,
  StatusBar,
  StatusBarPlugin,
  StatusBarStyle,
  StyleOptions,
  BackgroundColorOptions,
  SplashScreen,
  PushNotifications,
  Camera,
  requestCameraPermissions,
  requestGalleryPermissions,
  CameraSource,
  CameraResultType,
  App,
  URLOpenListenerEvent,
  AppLauncher,
  CanOpenURLResult,
  OpenURLResult,
  TransactionResult,
  IMyPosTransactionResult,
  MyposGlassTransactionResponse,
  ITimApiPaymentResult,
  TimApiTerminalConnectionParams,
  TimApiTerminalInterface,
  MyPosScannerType,
  SunmiScannerType,
  SunmiScannerPlugin,
  createCustomerDisplayServerPlugin,
  MyposGlassErrorCode,
  NfcState,
  MakePaymentOptions,
  MakeRefundOptions,
  MyposGlassError,
  MyposGlassPlugin,
  PosInfo,
  TransactionResponse,
  MyPosN5Plugin,
  TimApiPlugin,
  SumupPlugin,
  SunmiPrinterPlugin,
  SocketScannerPlugin,
  ScannerAppInfo,
  ScannerResultAction,
  SocketScannerPluginError,
  TimApiTerminalStatus,
  TimApiError,
  TimApiErrorResultCode,
  ConnectOptions,
  PayOptions,
  MyPosMiniPlugin,
  IMyPosMiniPlugin,
  IMyPosInfo,
  MyPosScannerResult,
  MyposN5PluginError,
  createCipheriv,
  createDecipheriv,
  createHmac,
  randomBytes,
  Cipher,
  pbkdf2Sync,
  NativeSettings,
  IOSSettings,
  Intercom,
  InAppBrowser,
  InAppBrowserObject,
  InAppBrowserOptions,
  Photo
};
